<div class="main ">
  <!-- !----!----! -->

  <div class="row">
    <div class="col-12 col-lg-8">
      <div class="dash-banner">
        <img src="./assets/img/Header-OTT.png" alt="banner" class="banner-img">
      </div>

      <div class="card-details">
        <div class="row">

          <!-- Today Usage -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="card mb-3 widget-chart card-shadow-warning">
              <div class="text-center">
                <h3 class="text-white ">Today Usage</h3>
                <!-- <div class="usage-bar"></div> -->
                <div class="text-white ">
                  <h5>Data Used : <span
                      class="badge bg-light text-dark ">{{daily_dq_usage}}</span></h5>
                  <h5>Time Usage : <span
                      class="badge bg-light text-dark ">{{daily_tq_usage}}</span></h5>
                </div>
              </div>
            </div>
          </div>
          <!-- Weekly Usage -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="card mb-3 widget-chart card-shadow-warning">
              <div class="text-center">
                <h3 class="text-white">This weekly</h3>
                <!-- <div class="usage-bar"></div> -->
                <div class="text-white">
                  <h5>Data Used : <span
                      class="badge bg-light text-dark ">{{weekly_dq_usage}}</span></h5>
                  <h5>Time Usage : <span
                      class="badge bg-light text-dark ">{{weekly_tq_usage}}</span></h5>
                </div>
              </div>
            </div>
          </div>
          <!-- Month Usage -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="card mb-3 widget-chart card-shadow-warning">
              <div class="text-center">
                <h3 class="text-white">This Month</h3>
                <!-- <div class="usage-bar"></div> -->
                <div class="text-white">
                  <h5>Data Used : <span
                      class="badge bg-light text-dark ">{{monthly_dq_usage}}</span></h5>
                  <h5>Time Usage :  <span
                      class="badge bg-light text-dark ">{{monthly_tq_usage}}</span></h5>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-6 col-lg-6">
          <div
            class="card mb-3 widget-chart card-btm-border card-shadow-warning gradient-bg">
            <div class="text-center">
              <img src="./assets/images/speed.png" alt>
            </div>
            <div class="text-center">
              <h3 class="text-white">Maximum Upload Bandwidth</h3>
              <p class="text-white">{{ uploadBandwidthMbps }} Mbps</p>
              <ngb-progressbar [value]="uploadBandwidthMbps"
                [max]="maxUploadMbps" type="info" [striped]="true"
                [animated]="true" showValue="true">
              </ngb-progressbar>
            </div>
          </div>
        </div>

        <div class="col-6 col-lg-6">
          <div
            class="card mb-3 widget-chart card-btm-border card-shadow-danger gradient-bg">
            <div class="text-center">
              <img src="./assets/images/speed.png" alt>
            </div>
            <div class="text-center">
              <h3 class="text-white">Maximum Download Bandwidth</h3>
              <p class="text-white">{{ downloadBandwidthMbps }} Mbps</p>
              <ngb-progressbar [value]="downloadBandwidthMbps"
                [max]="maxDownloadMbps" type="info" [striped]="true"
                [animated]="true" showValue="true">
              </ngb-progressbar>
            </div>
          </div>
        </div> -->
        </div>
      </div>

    </div>
    <div class="col-12 col-lg-4">

      <div class="plan-container">
        <div class="plan-header">
          <div *ngIf="account_state === 'Active'" class="plan-status">
            <span class="active_circle"></span>
            {{ account_state }}
          </div>

          <div *ngIf="account_state === 'Expired'" class="deactive-plan-status">
            <span class="deactive_circle"></span>
            {{ account_state }}
          </div>
          <div class="user-info">
            <strong class="fontStyle">{{user_firstname}} {{user_lastname}}</strong><br>
            {{this.user_id}}
          </div>
        </div>

        <div class="plan-body">
          <div class="plan-meta">
            <span><strong class="fontStyle">Plan Name </strong></span>
            <span>{{q1_plan_name}}</span>
          </div>

          <div class="plan-meta">
            <strong class="fontStyle">Monthly Usage From</strong>
            <strong class="fontStyle">{{monthly_dq_sts}}</strong>
          </div>

          <div class="plan-meta">
            <strong class="fontStyle">Due Date</strong>
            <strong class="fontStyle">{{expire_time}}</strong>
          </div>

          <div class="plan-meta">
            <strong class="fontStyle">Due Amt</strong>
            <strong class="fontStyle">₹{{q1_price}}</strong>
          </div>
          <!-- <div class="plan-meta">
            <strong class="fontStyle">This weekly</strong>
            <strong class="fontStyle">{{weekly_dq_usage}}</strong>
          </div>
          <div class="plan-meta">
            <strong class="fontStyle">This Month</strong>
            <strong class="fontStyle">{{monthly_dq_usage}}</strong>
          </div> -->
          <div class="plan-meta">
            <strong class="fontStyle">Maximum Upload Bandwidth</strong>
            <strong class="fontStyle">{{uploadBandwidthMbps}}Mbps</strong>
          </div>
          <div class="plan-meta">
            <strong class="fontStyle">Maximum Download Bandwidth</strong>
            <strong class="fontStyle">{{downloadBandwidthMbps}}Mbps</strong>
          </div>

          <div class="usage-bar" *ngIf="!isUnlimited">
            <div class="usage-bar-fill"
              [ngStyle]="{ width: usageBarWidth }"></div>
          </div>

          <div class="usage-bar" *ngIf="isUnlimited">
            <div class="usage-bar-fill unlimited"></div>
          </div>

          <small>
            Today Used: {{ daily_dq_usage }}
            <span *ngIf="isUnlimited">(Unlimited Plan)</span>
          </small>

          <!-- <div class="note-box">
            <span>Upgrade to enjoy Netflix, higher speeds & more.</span>
            <button>Upgrade</button>
          </div> -->
        </div>

        <!-- <div class="custom-btn btn-6"
          (click)="validateAndPay(q1_plan_name,q1_price)"><span>Pay
            Bill</span></div> -->

        <div
          class="custom-btn btn-6"
          [class.disabled]="!isPayBillEnabled()"
          [style.pointerEvents]="!isPayBillEnabled() ? 'none' : 'auto'"
          (click)="invoicePayment(q1_plan_name, q1_price)">
          <span>Pay Bill</span>
        </div>

        <!-- <div class="custom-btn btn-6"  [class.disabled]="!isPayBillEnabled()"
          [style.pointerEvents]="!isPayBillEnabled() ? 'none' : 'auto'" (click)="renewal()"><span>Upgrade
            Plan</span></div> -->
      </div>
    </div>
  </div>

</div>